import React, { useState } from "react";
import { useTheme } from "../Theme/ThemeProvider.js";
import {
  Container,
  HeroSection,
  ItemWrapper,
  HomeInfo,
  CardHome,
  ServicesWrapper,
} from "./styles";
import { plan } from "../../data/PlanData.js";
import { accordionItems } from "../../data/AccordionData.js";
import { infoBlocksHomeData } from "../../data/InfoBlockData.js";
import PlanCard from "../PlanCard";
import Accordion from "../Accordion";
import SideTabDesktop from "../SideTabDesktop/index.js";
import SideTabMobile from "../SideTabMobile/index.js";
import MainHeading from "../MainHeading";
import ContainerHome from "../HomeInfo";
import QrCode from "../QrCode";

export default function Hero() {
  const { isDarkMode } = useTheme();
  const [showQrModal, setShowQrModal] = useState(false);

  const toggleQrModal = () => setShowQrModal((prev) => !prev);

  return (
    <HeroSection isDarkMode={isDarkMode}>
      <MainHeading
        toggleQrModal={toggleQrModal}
        title={
          <>
            Proteção por{" "}
            <span className="DescriptionSubtext">criptografia</span> que só você
            tem
          </>
        }
        description="Proteja dados com criptografia avançada e biometria exclusiva. Baixe o Primatio Vault e controle sua segurança digital."
        buttonText="Conheça"
      />
      <HomeInfo>
        <div className="MainRow">
          <div className="LeftContent">
            <div className="TitleHome">
              Primatio Vault mais do que autenticação:
              <span className="DescriptionSubtext"> Prova de Vida</span>
            </div>
            <ContainerHome
              infoBlocks={infoBlocksHomeData}
              isDarkMode={isDarkMode}
            />
          </div>
          <img
            className="RightImage"
            src={
              isDarkMode
                ? "/assets/dark/primatio-ciclo-dark.png"
                : "/assets/light/primatio-ciclo-light.png"
            }
            alt="Imagem de Mão masculina"
          />
        </div>
      </HomeInfo>
      <Container>
        <img
          width="1100px"
          className="NoPasswordImage"
          src={
            isDarkMode
              ? "/assets/dark/no-password-dark.png"
              : "/assets/light/no-password-light.png"
          }
          alt="Imagem 'Zero Senha'"
        />
      </Container>
      <SideTabDesktop />
      <SideTabMobile />
      <CardHome>
        <div className="TitleHome">Escolha o plano ideal para você</div>
        {/* <PlanTabBar
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          /> */}
        <ItemWrapper>
          {plan.map((plan, index) => (
            <PlanCard key={index} {...plan} />
          ))}
        </ItemWrapper>
      </CardHome>
      {/* <Container>
       <CarouselWrapper />
      </Container> */}
      <ServicesWrapper>
        {/* <div className="ServicesInner">
          <div className="ServicesTitle">
            Tecnologia que transforma. Soluções que conectam.
          </div>
          <div className="ServicesCards">
            <div className="ServiceCard">
              <div>
                <img
                  src={
                    isDarkMode
                      ? "/assets/dark/ai-icon-dark.png"
                      : "/assets/light/ai-icon-light.png"
                  }
                  alt="Icone de robô para representar IA"
                />
              </div>
              <div className="ServiceSubtitle">Construção de Agentes de IA</div>
              <div className="ServiceDescription">
                Automatize decisões, reduza processos manuais e entregue
                experiências mais inteligentes. Criamos agentes de IA
                personalizados, treinados com dados reais do seu negócio,
                prontos pra atuar em atendimento, segurança, análise de dados e
                muito mais.
              </div>
            </div>
            <div className="ServiceCard">
              <img
                src={
                  isDarkMode
                    ? "/assets/dark/mobile-icon-dark.png"
                    : "/assets/light/mobile-icon-light.png"
                }
                alt="Icone de celular de desenvolvedor"
              />
              <div className="ServiceSubtitle">
                Desenvolvimento de Aplicativos iOS e Android
              </div>
              <div className="ServiceDescription">
                Do conceito ao app na loja — criamos soluções mobile nativas,
                rápidas, seguras e com foco total em experiência do usuário.
                Seja para transformar seu serviço em um app completo ou lançar
                um novo produto digital, nossa equipe cuida de tudo: design,
                back-end, integração e performance.
              </div>
            </div>
          </div>
        </div> */}
        <div className="ServicesInner">
          <div className="ServicesTitle">Esclareça suas dúvidas</div>
          {accordionItems.map((item, idx) => (
            <Accordion key={idx} title={item.title}>
              {item.description}
            </Accordion>
          ))}
        </div>
      </ServicesWrapper>
      {showQrModal && <QrCode onClose={toggleQrModal} />}
    </HeroSection>
  );
}
